// extracted by mini-css-extract-plugin
module.exports = {"container":"YandexSearchModal_container__TWqw-"};